import { useNavigate } from "react-router-dom";
import { Box, Typography, Tooltip } from "@mui/material";

import "../sidebar.scss";
import { RootState } from "../../../redux/store";
import { COLORS } from "../../../common/constants";
import { SideBarCompProp } from "./sidebarcomp.type";
import { useAppSelector } from "../../../hooks/useAppSelector";

const SideBarComp = ({
  src,
  heading,
  onClick,
  link,
  isInList = "false",
  actionCall,
  active = false,
  comingSoon = false,
}: SideBarCompProp) => {
  const navigate = useNavigate();

  const sidebarCollapsed = useAppSelector(
    (state: RootState) => state.globalcontent.sidebarCollapsed,
  );

  const handleLinkClick = () => {
    if (actionCall) actionCall();
    navigate(link);
  };

  const activeClassName = (path: string) => {
    if (window.location.pathname.includes(path)) {
      return true;
    }
    return false;
  };

  const iconActive = {
    backgroundColor: active
      ? COLORS.iconHover
      : COLORS.sidebarGray /* defines the background color of the image */,
    mask: `url(${src}) no-repeat center / contain`,
    WebkitMask: `url(${src}) no-repeat center / contain`,
  };

  return (
    <Tooltip title={sidebarCollapsed ? heading : ""} placement="right" arrow>
      <Box
        tabIndex={0}
        onClick={() => handleLinkClick()}
        onKeyPress={(event) => {
          if (event.key === "Enter") {
            navigate(link);
          }
        }}
        className={activeClassName(link) ? "active" : "inactive"}
      >
        <Box
          className={`sidebar-menu-item ${isInList === "true" ? "in-list" : ""} ${
            sidebarCollapsed ? "collapsed" : ""
          }`}
          onClick={onClick}
        >
          <Box sx={iconActive} className="sidebarIcon" />

          {!sidebarCollapsed && (
            <Typography className={`sidebarTxt ${active ? "active-text" : ""}`}>
              {heading}
            </Typography>
          )}
          {!sidebarCollapsed && comingSoon && (
            <span className="comingSoon">Coming soon</span>
          )}
        </Box>
      </Box>
    </Tooltip>
  );
};

export default SideBarComp;
